module.exports = __webpack_public_path__ + "img/coin.a7ce12e7.gif";